/* eslint-disable new-cap */
/* eslint-disable import/prefer-default-export */
import jsPDF from 'jspdf'
import { formatDateTime, getExtractPartDate } from './dates'

export const generateLibroReclamacionPDF = data => {
  const doc = new jsPDF()
  const marginX = 10
  let y = 15

  doc.setFont('helvetica', 'bold')

  const createHeader = (info, height = 8) => {
    console.log('checa info >', info)
    const fieldWidth = 190
    const titleWidth = 140

    doc.setFillColor(220, 220, 220)
    doc.setDrawColor(100)
    doc.rect(marginX, y, titleWidth, height, 'FD')
    doc.setDrawColor(0)
    doc.rect(marginX + titleWidth, y, fieldWidth - titleWidth, height + 8)
    doc.rect(marginX, y + 8, 26, height)
    doc.rect(marginX + 26, y + 8, 24, height)
    doc.rect(marginX + 50, y + 8, 56, height)
    doc.rect(marginX + 106, y + 8, 34, height)
    doc.rect(marginX, y + 16, fieldWidth, height + 8)

    doc.setFont('helvetica', 'bold')
    doc.setFontSize(10)
    doc.text('LIBRO DE RECLAMACIONES', marginX + 2, y + 5)
    doc.text('HOJA DE RECLAMACIÓN', marginX + titleWidth + 4, y + 7)
    doc.text(`[N° ${info.codigo}]`, marginX + titleWidth + 7, y + 11)
    doc.setFont('helvetica', 'normal')
    doc.setFontSize(9)
    const { dia, mes, anio } = getExtractPartDate(info.fechaRegistro)
    doc.text('FECHA', marginX + 2, y + 13)
    doc.text(dia.toString(), marginX + 35, y + 13)
    doc.text(mes, marginX + 72, y + 13)
    doc.text(anio.toString(), marginX + 120, y + 13)
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(12)
    y += 20
    doc.text('UNIVERSAL GAS S.R.L. - RUC: 20362013802', 105, y + 6, { align: 'center' })

    y += height
  }

  // Título
  doc.setFontSize(10)
  doc.text('Anexo I: Formato de Hoja de Reclamaciones del Libro de Reclamaciones', 105, y, { align: 'center' })
  y += 2
  createHeader(data)

  y += 6

  const sectionHeader = title => {
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(10)
    doc.setFillColor(220, 220, 220)
    doc.setDrawColor(100)
    doc.rect(marginX, y, 190, 8, 'FD') // F = Fill, D = Draw
    doc.setTextColor(0)
    doc.text(title, marginX + 2, y + 5)
    y += 10
  }

  const drawField = (label, value, height = 8) => {
    doc.setFont('helvetica', 'normal')
    const fieldWidth = 190
    const labelWidth = 50
    const valueX = marginX + labelWidth + 2
    const valueWidth = fieldWidth - labelWidth - 2

    doc.setDrawColor(0)
    doc.rect(marginX, y, labelWidth, height)
    doc.rect(valueX, y, valueWidth, height)

    doc.setFontSize(9)
    doc.text(label, marginX + 2, y + 5)
    doc.text(doc.splitTextToSize(value || '', valueWidth - 4), valueX + 2, y + 5)

    y += height
  }

  // Sección 1
  sectionHeader('1. IDENTIFICACIÓN DEL CONSUMIDOR RECLAMANTE')
  drawField('NOMBRE', data.nombresApellidos)
  drawField('DOCUMENTO', `${data.tipoDocumento}: ${data.documento}`)
  drawField('DOMICILIO', data.direccion)
  drawField('TELÉFONO', data.telefono)
  drawField('CORREO ELECTRÓNICO', data.email)

  y += 2
  // Sección 2
  sectionHeader('2. IDENTIFICACIÓN DEL BIEN CONTRATADO')
  drawField('TIPO', data.tipoBien)
  drawField('DESCRIPCIÓN', data.descripcionProducto)
  drawField('MONTO RECLAMADO', `S/ ${data.montoReclamado}`)

  y += 2
  // Sección 3
  sectionHeader('3. DETALLE DE LA RECLAMACIÓN Y PEDIDO DEL CONSUMIDOR')
  drawField('TIPO', data.tipoReclamo)
  drawField('RECLAMO', data.detalleReclamo, 20)
  drawField('PEDIDO', data.infoPedido, 20)

  y += 2
  // Sección 4
  sectionHeader('4. OBSERVACIONES Y ACCIONES ADOPTADAS POR EL PROVEEDOR')
  drawField('OBSERVACIÓN', data.observacionAtencion || 'Aún no atendido', 20)
  drawField('FECHA DE COMUNICACIÓN', data.fechaAtencion ? formatDateTime(data.fechaAtencion) : 'Aún no atendido', 12)
  doc.text('DE LA RESPUESTA', marginX + 2, y - 3)

  // Notas legales
  y += 10
  doc.setFontSize(8)
  doc.text('* La formulación del reclamo no impide acudir a otras vías de solución de controversias ni es requisito previo para interponer una denuncia ante el INDECOPI.', marginX, y)
  y += 5
  doc.text('* El proveedor debe dar respuesta al reclamo en un plazo no mayor a quince (15) días hábiles, el cual es improrrogable.', marginX, y)

  doc.save(`Libro_Reclamaciones_${data.codigo}.pdf`)
}
